import {Spinner} from "react-bootstrap";

import styled from 'styled-components'
import {useSelector} from "react-redux";

const Wrapper = styled.div`

    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 1000000;

    .cover {
        z-index: 10000000 !important;
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;
        background-color: rgba(0, 0, 0, 0.25);
    }

    /* spinner */

    .spinner {
        position: fixed !important;
        top: 45%;
        left: 48%;
        width: 50px;
        height: 50px;
        z-index: 1000 !important;
    }

`


const Loader = () => {

    const loading = useSelector((state) => state.meta.loading);


    if (!loading) return null;
    return (
        <Wrapper>
            <div>
                <div className="cover">{' '}</div>
                <div><Spinner variant="primary" className="spinner" animation="border"/>
                </div>
            </div>

        </Wrapper>
    );
};

export default Loader;
